import { ButtonBase, styled } from '@mui/material'
import HoverSVG from '@public/icons/icon-favorite-hover.svg'
import NormalSVG from '@public/icons/icon-favorite-normal.svg'
import ActiveSVG from '@public/icons/icon-favorite-variant.svg'
import { NftType } from '@src/constants/bookmark'
import useBookmarkNFT from '@src/hooks/graphql/useBookmarkNFT'
import { FC, useCallback } from 'react'

const StyledButton = styled(ButtonBase)`
  width: 30px;
  aspect-ratio: 1;
  margin-left: 5px;
  color: white;
  background-image: url('${NormalSVG.src}');
  :hover {
    background-image: url('${HoverSVG.src}');
  }
  &.active {
    background-image: url('${ActiveSVG.src}');
  }
`

const ApeironBookmarkButton: FC<Props> = props => {
  const { isBookmarked, nftType, tokenId, onChange } = props

  const { mutate: bookmark } = useBookmarkNFT()

  const handleOnClick = useCallback(async () => {
    const success = await bookmark({
      nftType,
      tokenID: tokenId,
      isBookmarked: !isBookmarked
    })

    if (success && onChange) {
      onChange(!isBookmarked)
    }
  }, [bookmark, isBookmarked, nftType, onChange, tokenId])

  return (
    <StyledButton
      aria-label='bookmark button'
      className={isBookmarked ? 'active' : undefined}
      onClick={handleOnClick}
    />
  )
}

type Props = {
  isBookmarked: boolean
  nftType: NftType
  tokenId: string
  onChange?: (bookmarked: boolean) => void
}

export default ApeironBookmarkButton
